import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'
import { removeGarbageFromString } from './remove-garbage'

const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i

export function findTracksThatContainUrl(tracks: Track[], field: TrackFields) {
  return tracks.filter((t: any) => urlRegex.test(t[field]))
}

export function removeUrl(track: any, values: any[]): string {
  const field: TrackFields = values[0]

  let s: string = track[field]

  s = s.replace(new RegExp(urlRegex, 'gi'), '')

  return removeGarbageFromString(s)
}
